import React from 'react'
// libs
import { FieldArray } from 'redux-form'
import { ReduxInput } from 'components/FormElements'
// components
import renderUsers from 'components/FormElements/UsersList'
// constants
import { ENTITIES } from 'constants/entities'
import { SELECT_GROUP_LABELS } from 'constants/forms'
// types
import { IOption } from 'components/FormElements/Select'
import { GroupBase } from 'react-select'
import { FieldType } from 'types/graphql'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// views
import { ShowFunctionWrapper } from './views'
// utils
import { required } from 'utils/validators'

interface Props {
  field: string
}

const ShowFunction: React.FC<Props> = ({ field }) => {
  const { basicFields } = React.useContext(RiskTemplateAPIContext)

  const fieldsOptions = basicFields
    .filter((field) => field.fieldType === FieldType.Lookup)
    .map((field) => ({
      label: field.parentFieldId
        ? `${basicFields.find((item) => item.id === field.parentFieldId)?.label}: ${field.label}`
        : field.label,
      value: field.id,
      toField: true
    }))

  const prepareOptions = (options: (IOption & { entity: string })[]): GroupBase<IOption>[] => {
    return [
      { label: SELECT_GROUP_LABELS.FIELDS, options: fieldsOptions },
      {
        label: SELECT_GROUP_LABELS.USERS_AND_POSITIONS,
        options: [
          { label: '(All Users)', value: 'ALL' },
          ...options.map((item) => ({
            value: item.value,
            label: item.label,
            toUser: item.entity === ENTITIES.USER,
            toPosition: item.entity === ENTITIES.POSITION
          }))
        ]
      }
    ]
  }

  return (
    <ShowFunctionWrapper>
      <ReduxInput validate={required} label='Function Name' name={`${field}.functionName`} />
      <FieldArray component={renderUsers} name={`${field}.availableTo`} prepareOptions={prepareOptions} />
    </ShowFunctionWrapper>
  )
}

export default ShowFunction
